import { type Static, Type } from '@sinclair/typebox';

export const ListCountriesReplySchema = Type.Array(Type.String());
export type ListCountriesReply = Static<typeof ListCountriesReplySchema>;
